<div *ngIf="_isLoading" class="query-builder-loading">
  <span class="spinner-border" role="status" aria-hidden="true"></span>
</div>

<form [formGroup]="_filterSelectForm" [hidden]="_isLoading">
  <app-md-select label="Select Filter"
                 formControlName="selectedFilter"
                 [options]="_queryFiltersList">
  </app-md-select>
</form>
<!-- The container stays visible: it is empty until the query builder is initialised,
     and hiding it would initialise the plugin inside a display:none element -->
<div id="builder" class="builder"></div>

<div *ngIf="this._isCct" [hidden]="_isLoading">
  <form [formGroup]="_cctForm">
    <div class="row">
      <div class="col">
        <label for="ccTrue" class="input-label ml-0">Text If Condition Matches:</label>
        <textarea id="cctTrue" name="cctTrue" formControlName="cctTrue" class="form-control" rows="5"></textarea>
      </div>
      <div class="col">
        <label for="cctFalse" class="input-label ml-0">Text If Condition NOT Matches:</label>
        <textarea id="cctFalse" name="cctFalse" formControlName="cctFalse" class="form-control" rows="5"></textarea>
      </div>
    </div>
  </form>
</div>

<button *ngIf="_updateFilterButton" [hidden]="_isLoading" class="btn btn-primary save pull-left" (click)="displaySaveFilterModel(true)">Save As Filter</button>
<button *ngIf="!_updateFilterButton" [hidden]="_isLoading" class="btn btn-primary save pull-left" (click)="displaySaveFilterModel(false)">Save Filter</button>
<button *ngIf="_updateFilterButton" [hidden]="_isLoading" class="btn btn-primary save pull-left" (click)="updateFilter()">Update Filter</button>
<button class="btn btn-primary save pull-right" [hidden]="_isLoading" (click)="savePressed()" id="queryBuilderSaveBtn">Save</button>

<app-query-builder-filter #queryBuilderFilter
                          *ngIf="_showFilterModel"
                          [(_parentSqlQuery)]="_sqlQuery"
                          [(_parentPageTitle)]="_pageTitle"
                          [(_isSaveAsButton)]="_isSaveAsButton"
                          [(_queryFiltersList)]="_queryFiltersList"
                          [(_parentSelectedFilter)]="_parentSelectedFilter"
                          (closeRefreshEvent)="refreshQueryBuilderFilter($event)"
                          (modelOpenEvent)="_showFilterModel = $event">
</app-query-builder-filter>
